/** Owns custom-role modal state and delegates persistence through the role facade. */
export function createCustomRoleController({
  documentRef = document,
  roleFacade,
  getRoles,
  refreshRoles,
  showToast,
  showConfirm,
  openModal,
  closeModal,
}) {
  let editingCustomCode = null;
  const getModal = () => documentRef.getElementById('aichat-custom-role-modal');
  const getForm = () => documentRef.getElementById('aichat-custom-role-form');

  function closeCustomRoleModal() {
    const modal = getModal();
    if (modal) {
      modal.classList.remove('show');
      closeModal(modal);
    }
    editingCustomCode = null;
  }

  function openCustomRoleModal(role = null) {
    editingCustomCode = role ? role.code : null;
    const modal = getModal();
    if (!modal) return;
    const form = getForm();
    if (form) {
      form.name.value = role?.name || '';
      form.description.value = role?.description || '';
      form.systemPrompt.value = role?.systemPrompt || '';
      form.greeting.value = role?.greeting || '';
    }
    const title = documentRef.getElementById('aichat-custom-role-modal-title');
    if (title) title.textContent = role ? '编辑自定义角色' : '创建自定义角色';
    modal.classList.add('show');
    openModal(modal, { onRequestClose: closeCustomRoleModal });
  }

  async function saveCustomRole() {
    const form = getForm();
    if (!form) return;
    const payload = {
      name: form.name.value.trim(),
      description: form.description.value.trim() || null,
      systemPrompt: form.systemPrompt.value.trim(),
      greeting: form.greeting.value.trim() || null,
      toolsEnabled: true,
    };
    if (!payload.name || !payload.systemPrompt) {
      showToast('名称和系统提示词为必填项', 'error');
      return;
    }
    try {
      let result;
      if (editingCustomCode) {
        const role = getRoles().find((item) => item.code === editingCustomCode);
        if (!role) throw new Error('找不到要编辑的角色');
        result = await roleFacade.updateUserRole(role.id, payload);
      } else {
        result = await roleFacade.createUserRole(payload);
      }
      if (result?.success !== false && result?.id) {
        const wasEditing = Boolean(editingCustomCode);
        closeCustomRoleModal();
        await refreshRoles();
        showToast(wasEditing ? '角色已更新' : '自定义角色已创建');
      } else if (result?.error) {
        showToast(`保存失败: ${result.error}`, 'error');
      }
    } catch (error) {
      showToast(`保存失败: ${error.message}`, 'error');
    }
  }

  async function deleteCustomRole(code) {
    const confirmed = await showConfirm('删除角色', '确定删除此自定义角色？');
    if (!confirmed) return;
    try {
      const role = getRoles().find((item) => item.code === code);
      if (!role) return;
      await roleFacade.deleteUserRole(role.id);
      await refreshRoles();
      showToast('角色已删除');
    } catch (error) {
      showToast(`删除失败: ${error.message}`, 'error');
    }
  }

  return {
    openCustomRoleModal,
    closeCustomRoleModal,
    saveCustomRole,
    deleteCustomRole,
  };
}
